export default __webpack_public_path__ + "static/media/esophagus_plot_male.4dc305f9.png";